const axios = require('axios')

const fixTitle = (str) => str.replace(/\s-\s.*$/, '')
const buildArticle = obj => ({
    id: obj.id,
    title: fixTitle(obj.title),
    summary: obj.summary,
    text: (obj.text || '').replace(/\[.*\]$/, ''),
    image: obj.image || '',
    url: `/n/${encodeURIComponent(obj.publisher)}/${encodeURIComponent(fixTitle(obj.title || ''))}`,
    source: obj.link,
    date: obj.published,
    author: obj.publisher,
});

export default {
    install(vue) {
        const GetLatest = async () => vue.$cache.Get('news_cache', 5, async () => {
            return await axios
                .get(`https://hmyrecipefinder.co/app/news`)
                .then(response => response.data.map(buildArticle));
        });

        const GetArticle = async (source, title) => {
            const cachedArticle = Array.from(await GetLatest()).find(obj => obj.author === source && obj.title === title);
            if (typeof cachedArticle !== 'undefined') return cachedArticle;

            return await axios
                .get(`https://hmyrecipefinder.co/app/article?title=${title}`)
                .then(response => response.data.map(buildArticle)[0])
        }

        vue.prototype.$news = {
            GetLatest,
            GetArticle,
        };
        vue.$news = {
            GetLatest,
            GetArticle,
        };
    }
}